module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/save-6ef88afce4fa94a749dede6059e7cbe0.svg";